import unauthenticated from './http-clients/unauthenticated'

export default {
  signUp(data) {
    return unauthenticated({
      url: '/sign-up',
      method: 'post',
      data
    })
  },

  confirmEmail(data) {
    return unauthenticated({
      url: '/confirm-email',
      method: 'post',
      data
    })
  },

  finishRegistration(data) {
    return unauthenticated({
      url: '/finish-registration',
      method: 'post',
      data
    })
  },

  forgotPassword (data) {
    return unauthenticated({
      url: '/forgot-password',
      method: 'post',
      data
    })
  },

  resetPassword(data) {
    return unauthenticated({
      url: '/reset-password',
      method: 'post',
      data
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/register.js